import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { HighlightBox } from 'packages/common-frontend/components/HighlightBox';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { PortfolioLtvChartTemplateForCreditFacility } from 'packages/portfolio/ui/risk/PortfolioLtvChartTemplateForCreditFacility';

type BorrowerLtvContainerProps = { organizationId: string };
export const BorrowerLtvContainer = ({
  organizationId,
}: BorrowerLtvContainerProps) => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Box height="100%">
      <Heading as="h3" fontSize="24px" mb="24px">
        LTV
      </Heading>
      <HighlightBox backgroundColor={colors.millet[50]}>
        <PortfolioLtvChartTemplateForCreditFacility
          organizationId={organizationId}
          creditFacilityId={creditFacilityId}
        />
      </HighlightBox>
    </Box>
  );
};
